// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Developer_TheComp__hD_9Y"};